'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omitBy2 = require('lodash/omitBy');

var _omitBy3 = _interopRequireDefault(_omitBy2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _isNil2 = require('lodash/isNil');

var _isNil3 = _interopRequireDefault(_isNil2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _cloneDeep2 = require('lodash/cloneDeep');

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _reactRouter = require('react-router');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _common = require('../common');

var _LendingList = require('./LendingList');

var _LendingList2 = _interopRequireDefault(_LendingList);

var _LendingSidebar = require('./LendingSidebar');

var _LendingSidebar2 = _interopRequireDefault(_LendingSidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var LendingPage = (_dec = (0, _mobxReact.inject)('SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(LendingPage, _Component);

  function LendingPage(props) {
    _classCallCheck(this, LendingPage);

    var _this = _possibleConstructorReturn(this, (LendingPage.__proto__ || Object.getPrototypeOf(LendingPage)).call(this, props));

    _this.searchString = 'INITIAL';


    var location = _reactRouter.browserHistory.getCurrentLocation(),
        hasQuery = !!Object.keys(location.query).length;

    if (!hasQuery) {
      // Nothing in the URL, so seed it from the store. That gives the list a query to fetch from,
      // and re-applies any filters set earlier in the session, so returning to the page from the
      // nav link keeps them. Same behaviour as Case Tracking. Reset All clears them.
      _this.onFilterChange({});
      return _possibleConstructorReturn(_this);
    }

    _this.setStateFromProps();
    return _this;
  }

  _createClass(LendingPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          SessionStore = _props.SessionStore,
          filters = _props.UiStore.lendingPage.filters;


      SessionStore.trackEvent('LENDING_LIST_MOUNTED', { filters: filters });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setStateFromProps();
    }
  }, {
    key: 'setStateFromProps',
    value: function setStateFromProps() {
      var UiStore = this.props.UiStore,
          _browserHistory$getCu = _reactRouter.browserHistory.getCurrentLocation(),
          search = _browserHistory$getCu.search,
          query = _browserHistory$getCu.query;

      // Only reload query if search string has changed
      if (search === this.searchString) {
        return;
      }

      var newQuery = (0, _cloneDeep3.default)(query);
      Object.keys(newQuery).forEach(function (key) {
        if (newQuery[key] && !(0, _isArray3.default)(newQuery[key])) {
          newQuery[key] = [newQuery[key]];
        }
      });

      UiStore.lendingPage.filters = newQuery;
      this.searchString = search;
    }
  }, {
    key: 'onResetAll',
    value: function onResetAll() {
      var _browserHistory$getCu2 = _reactRouter.browserHistory.getCurrentLocation(),
          pathname = _browserHistory$getCu2.pathname,
          _props2 = this.props,
          SessionStore = _props2.SessionStore,
          lendingPage = _props2.UiStore.lendingPage;

      SessionStore.trackEvent('LENDING_PAGE_RESET_ALL');

      lendingPage.filters = {};
      lendingPage.ordering = [];
      _reactRouter.browserHistory.push({ pathname: pathname, query: {} });
    }
  }, {
    key: 'onFilterChange',
    value: function onFilterChange(changes) {
      var _props3 = this.props,
          SessionStore = _props3.SessionStore,
          UiStore = _props3.UiStore,
          _browserHistory$getCu3 = _reactRouter.browserHistory.getCurrentLocation(),
          pathname = _browserHistory$getCu3.pathname;

      var query = (0, _omit3.default)(UiStore.lendingPage.query, ['ordering']);

      if (Object.keys(changes).length) {
        SessionStore.trackEvent('LENDING_LIST_FILTER_CHANGE', { changes: changes });
      }

      query = _extends({}, query, changes);
      query = (0, _omitBy3.default)(query, _isNil3.default);
      _reactRouter.browserHistory.push({ pathname: pathname, query: query });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _common.Page,
        { name: 'lending', hasSidebar: true, type: 'list' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Lending' }),
        _react2.default.createElement(
          _common.Page.Sidebar,
          null,
          _react2.default.createElement(_LendingSidebar2.default, { onResetAll: this.onResetAll, onFilterChange: this.onFilterChange })
        ),
        _react2.default.createElement(
          _common.Page.Content,
          null,
          _react2.default.createElement(_LendingList2.default, { searchString: this.searchString })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LendingPage;
}(_react.Component), _class2.propTypes = {
  SessionStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = LendingPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LendingPage, 'LendingPage', '/app/src/components/page-lending/LendingPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-lending/LendingPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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